module.exports = __webpack_public_path__ + "static/media/battery-three-quarters.2adbd3f6.svg";